import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full text-left mb-10 text-brown" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-2xl font-medium md:font-semibold leading-[32px] mb-10 text-center" }
const _hoisted_4 = { class: "mb-5 text font-bold" }
const _hoisted_5 = { class: "mb-5 text" }
const _hoisted_6 = { class: "mb-5 text font-bold" }
const _hoisted_7 = { class: "mb-5 list-disc pl-5 space-y-1 text" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "font-bold" }


import { RuneOfTheDayResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayRuneResult',
  props: {
    prediction: {}
  },
  setup(__props: any) {



const { t } = useI18n();

function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: `${__props.prediction.image}`,
      alt: "DayRune",
      class: "mx-auto mb-2 w-[109px] h-40 md:w-[146px] md:h-[213px]"
    }, null, 8, _hoisted_2),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)("calculators.day-rune.results.day-rune", {
          name: __props.prediction.name,
          code: capitalize(__props.prediction.code),
        })), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("calculators.day-rune.results.meaning")), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.prediction.meaning), 1),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("calculators.day-rune.results.today-meaning")), 1),
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.prediction.today, (val, key) => {
        return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(val), 1))
      }), 128))
    ]),
    _createElementVNode("p", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("calculators.day-rune.results.day-tip", { name: __props.prediction.name })), 1),
      _createTextVNode(" " + _toDisplayString(__props.prediction.advice), 1)
    ])
  ]))
}
}

})